import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import "../css/MenuBar.css";

const MenuBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const activeClass = ({ isActive }) =>
    isActive ? "active-menu" : "";

  return (
    <nav className="menu-bar-wrapper">

      <div className="hamburger-icon" onClick={toggleMenu}>
        {isOpen ? (
          <FaTimes />
        ) : (
          <div className="menu-text-icon">
            <FaBars />
            <span>MENU</span>
          </div>
        )}
      </div>


      <div className={`menu-bar-container ${isOpen ? "open" : ""}`}>

        <ul className="main-menus">


          <li className="menu-item">
            <NavLink
              to="/"
              end
              className={activeClass}
              onClick={closeMenu}
            >
              HOME
            </NavLink>
          </li>



          <li className="menu-item has-dropdown">

            <NavLink
              to="/about"
              className={activeClass}
              onClick={closeMenu}
            >
              ABOUT
              <FaChevronDown className="arrow-icon" />
            </NavLink>


            <div className="dropdown-content">

              <NavLink 
                to="/vision-mission"
                onClick={closeMenu}
              >
                Our Vision
              </NavLink>


              <NavLink 
                to="/about"
                onClick={closeMenu}
              >
                Principal's Message
              </NavLink>


              <NavLink
                to="/history-milestone"
                onClick={closeMenu}
              >
                History & Milestone
              </NavLink>


              <NavLink
                to="/management-team"
                onClick={closeMenu}
              >
                SAHARA MANAGEMENT
              </NavLink>


              <NavLink
                to="/about"
                onClick={closeMenu}
              >
                SAHARA ADVISORS
              </NavLink>


              <NavLink
                to="/career"
                onClick={closeMenu}
              >
                CAREERS
              </NavLink>

            </div>

          </li>



          <li className="menu-item has-dropdown">

            <NavLink
              to="/curriculum"
              className={activeClass}
              onClick={closeMenu}
            >

              CURRICULA

              <FaChevronDown className="arrow-icon" />

            </NavLink>


            <div className="dropdown-content">

              <NavLink
                to="/primarycurricula"
                onClick={closeMenu}
              >
                Primary Curricula
              </NavLink>


              <NavLink
                to="/seeb"
                onClick={closeMenu}
              >
                SEEB
              </NavLink>

            </div>

          </li>



          <li className="menu-item has-dropdown">

            <NavLink
              to="/school-level"
              className={activeClass}
              onClick={closeMenu}
            >

              SCHOOL LEVELS

              <FaChevronDown className="arrow-icon" />

            </NavLink>


            <div className="dropdown-content">


              <NavLink
                to="/pre-primary"
                onClick={closeMenu}
              >
                Pre Primary
              </NavLink>


              <NavLink
                to="/primary-school"
                onClick={closeMenu}
              >
                Primary School
              </NavLink>


              <NavLink
                to="/secondary-school"
                onClick={closeMenu}
              >
                Secondary School
              </NavLink>


              <NavLink
                to="/high-school"
                onClick={closeMenu}
              >
                High School
              </NavLink>


            </div>


          </li>
                    <li className="menu-item has-dropdown">

            <NavLink
              to="/student-life"
              className={activeClass}
              onClick={closeMenu}
            >

              STUDENT LIFE

              <FaChevronDown className="arrow-icon" />

            </NavLink>


            <div className="dropdown-content">


              <NavLink
                to="/school-gems"
                onClick={closeMenu}
              >
                Holistic Education Framework
              </NavLink>


              <NavLink
                to="/facilitiespage"
                onClick={closeMenu}
              >
                Facilities
              </NavLink>


              <NavLink
                to="/eca"
                onClick={closeMenu}
              >
                Extra Curricular Activities
              </NavLink>


              <NavLink
                to="/co-curricular"
                onClick={closeMenu}
              >
                Co Curricular Activities
              </NavLink>


              <NavLink
                to="/events&activities"
                onClick={closeMenu}
              >
                Events & Activities
              </NavLink>


              <NavLink
                to="/parent-engagement"
                onClick={closeMenu}
              >
                Parent Engagement
              </NavLink>


              <NavLink
                to="/safety-security"
                onClick={closeMenu}
              >
                Safety & Security
              </NavLink>


              <NavLink
                to="/happiness-index"
                onClick={closeMenu}
              >
                Happiness Index
              </NavLink>


              <NavLink
                to="/university-placement"
                onClick={closeMenu}
              >
                University Placement
              </NavLink>


              <NavLink
                to="/faculty"
                onClick={closeMenu}
              >
                Faculty
              </NavLink>


            </div>

          </li>




          <li className="menu-item has-dropdown">


            <NavLink
              to="/admission"
              className={activeClass}
              onClick={closeMenu}
            >

              ADMISSIONS

              <FaChevronDown className="arrow-icon" />

            </NavLink>



            <div className="dropdown-content">


              <NavLink
                to="/admission-process"
                onClick={closeMenu}
              >
                ADMISSION PROCESS
              </NavLink>


              <NavLink
                to="/feestructure"
                onClick={closeMenu}
              >
                FEES
              </NavLink>


              <NavLink
                to="/admissionenquiryform"
                onClick={closeMenu}
              >
                ADMISSION FORM
              </NavLink>


              <NavLink
                to="/book-meeting"
                onClick={closeMenu}
              >
                BOOK MEETING
              </NavLink>


              <NavLink
                to="/admission"
                onClick={closeMenu}
              >
                ADMISSION
              </NavLink>


              <NavLink
                to="/contact"
                onClick={closeMenu}
              >
                ENQUIRY FORM
              </NavLink>


            </div>


          </li>




          <li className="menu-item">

            <NavLink
              to="/career"
              className={activeClass}
              onClick={closeMenu}
            >
              CAREERS
            </NavLink>

          </li>



          <li className="menu-item">

            <NavLink
              to="/scholarship"
              className={activeClass}
              onClick={closeMenu}
            >
              SCHOLARSHIP
            </NavLink>

          </li>
                    <li className="menu-item has-dropdown">

            <NavLink
              to="/resources"
              className={activeClass}
              onClick={closeMenu}
            >

              RESOURCES

              <FaChevronDown className="arrow-icon" />

            </NavLink>


            <div className="dropdown-content">


              <NavLink
                to="/recent-blogs"
                onClick={closeMenu}
              >
                Recent Blogs
              </NavLink>


              <NavLink
                to="/most-read"
                onClick={closeMenu}
              >
                Most Read
              </NavLink>


              <NavLink
                to="/trending-news"
                onClick={closeMenu}
              >
                Trending News
              </NavLink>


              <NavLink
                to="/campus-news"
                onClick={closeMenu}
              >
                Campus News
              </NavLink>


              <NavLink
                to="/videos"
                onClick={closeMenu}
              >
                Videos
              </NavLink>


              <NavLink
                to="/featured-blogs"
                onClick={closeMenu}
              >
                Featured Blogs
              </NavLink>


            </div>


          </li>




          <li className="menu-item">

            <NavLink
              to="/public-disclosure"
              className={activeClass}
              onClick={closeMenu}
            >
              MANDATORY PUBLIC DISCLOSURE
            </NavLink>

          </li>




          <li className="donate-btn">

            <NavLink
              to="/fund-raising"
              onClick={closeMenu}
            >
              DONATE NOW
            </NavLink>

          </li>




          <li className="menu-item highlight-menu">

            <NavLink
              to="/poll"
              onClick={closeMenu}
            >
              VOTE BEST SCHOOL
            </NavLink>

          </li>


        </ul>


      </div>


    </nav>
  );
};


export default MenuBar;